<template>
  <div class="flex flex-col">
    <h3 class="text-title-small text-on-surface-variant mb-1">Textantworten</h3>
    <div class="flex flex-col gap-0.5">
      <TextFeedbackItem
        v-for="textFeedbacksForQuestion in texts"
        :key="textFeedbacksForQuestion.question.id"
        :text-feedbacks="textFeedbacksForQuestion"
        :expanded="expandedQuestionId == textFeedbacksForQuestion.question.id"
        @click="emits('questionClicked', textFeedbacksForQuestion.question.id)"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import TextFeedbackItem from './TextFeedbackItem.vue'
  import type { TextAnalysis } from '@/core/models/surveys-analytics'

  interface Props {
    texts: ReadonlyArray<TextAnalysis>
    expandedQuestionId: string | null
  }

  defineProps<Props>()

  const emits = defineEmits<{
    (e: 'questionClicked', questionId: string): void
  }>()
</script>
